import * as types from "./mutation-types";

export default {
  [types.SET_CONCEDENTES](state, payload) {
    state.concedentes = payload;
  },
  [types.SET_CONCEDENTE](state, payload) {
    state.concedente = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
